// extracted by mini-css-extract-plugin
export default {"container":"returns_container__RxK6R","spin":"returns_spin__aaVR5","header":"returns_header__WRkJ7","title":"returns_title__TAlLx","content":"returns_content__xl2ty"};